module.exports = __webpack_public_path__ + "img/app_icon_29.7c97fa6d.png";